import { Box, styled } from "@mui/material";

export const ContactCard = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  backgroundColor: "#F7F7F7",
  borderRadius: "8px",
  transition: ".2s",
  minWidth: "400px",
  border: "1px solid #CBCBCB",
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}));

export const ContainerInfo = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  padding: "8px",
}));

export const ContainerActions = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-around",
  gap: "8px",
  borderRadius: "0 8px 8px 0",
  padding: "8px",
  borderLeft: "1px solid #CBCBCB",
}));
